





















import { Component, Vue } from 'vue-property-decorator'
import languages, { Lang } from '@/languages'
import Issues from '@/components/Issues.vue'
import { GithubIssue, GithubResponse } from '@/@types/Github'
import axios, { AxiosResponse } from 'axios'
import Logo from '@/components/Logo.vue'
const frequentChars = 'いうんかし'
class Label {
  public name: string;
  public active = false;
  constructor (name: string, active?: boolean) {
    this.name = name
    this.active = active || false
  }
}

@Component({
  components: {
    Issues,
    Logo
  }
})

export default class App extends Vue {
  public page=1;
  public languages: Array<Lang> = languages;
  public lang = '';
  public labels: Array<Label> = [new Label('good first issue', true), new Label('help wanted')]
  public issues: Array<GithubIssue> = []

  public changeLang (): void {
    this.issues = []
    this.page = 1
    this.getIssues()
  }

  public paginate (): void {
    this.page++
    this.getIssues()
  }

  public async getIssues (): Promise<void> {
    const baseQuery: string = [
      'is:issue',
      'is:open',
      `language:"${this.lang}"`
    ].concat(this.labels.filter((label: Label): boolean => {
      return label.active
    }).map((label: Label): string => {
      return `label:"${label.name}"`
    }).join(' ')).join(' ')
    const getIssuesURL = `https://api.github.com/search/issues?q=${encodeURIComponent(baseQuery)}%20${encodeURIComponent(frequentChars.split('').join(' OR '))}`
    const result: AxiosResponse<GithubResponse> = await axios.get(getIssuesURL, {
      params: {
        page: this.page,
        sort: 'created',
        order: 'desc'
      }
    }).catch(() => {
      alert('Github API のアクセスに失敗しました。1分あたり10回までのリクエスト制限に達しているか、Githubが障害を起こしているかこのサービスのバグです')
      return { data: {} } as AxiosResponse
    })

    result.data.items.map((issue: GithubIssue) => {
      if (this.issues.filter((alreadyIssue) => {
        return alreadyIssue.id === issue.id
      }).length === 0) {
        this.issues.push(issue)
      }
    })
  }
}
